<ion-header>
  <app-header-small title="Order complete" [isScrollStartPosition]="isScrollStartPosition"></app-header-small>
</ion-header>

<ion-content [scrollEvents]="true" (ionScroll)="updateHeaderLogo($event)">
  <div class="container">
    <div class="container__content">
      <div class="field" *ngIf="!isTab">
        <!--        TODO: When the backend work ith email and sms sending will be done uncomment this-->
        <!--        <div class="field__title">Order receipt-->
        <!--          <svg class="field__title-icon" xmlns="http://www.w3.org/2000/svg">-->
        <!--            <use xlink:href="./assets/images/icons-sprite.svg#icon-mail"></use>-->
        <!--          </svg>-->
        <!--        </div>-->
        <!--        <ion-text class="field__description">Enter email or text order receipt</ion-text>-->
        <!--        <div class="field__content">-->
        <!--          <input placeholder="Enter email" class="field__input">-->

        <!--          <ion-item lines="none" class="field__checkbox-wrapper">-->
        <!--            <ion-label class="field__checkbox-label">Send my SMS receipt to (252) 223-0020</ion-label>-->
        <!--            <ion-checkbox class="field__checkbox" slot="start">-->
        <!--            </ion-checkbox>-->
        <!--          </ion-item>-->

        <!--          <ion-item lines="none" class="field__checkbox-wrapper">-->
        <!--            <ion-label class="field__checkbox-label">I'd like occasional updates from this restaraunt and Kyoo, and a link-->
        <!--              for $1-->
        <!--            </ion-label>-->
        <!--            <ion-checkbox class="field__checkbox" slot="start">-->
        <!--            </ion-checkbox>-->
        <!--          </ion-item>-->
        <!--          <ion-button class="checkout-btns__btn" color="brand" expand="block">-->
        <!--            Get receipt-->
        <!--          </ion-button>-->
        <ion-button fill="clear" class="checkout-btns__btn checkout-btns__cancel-btn"
                    expand="block" (click)="backToLocation()">
          Place another order
        </ion-button>
        <div *ngIf="isFridge" class="fridge-container">
          <div class="fridge-text">Fridge still locked?</div>
          <button [disabled]="!sendUnlock || isLoading" class="brand-color send-command" (click)="unlockFridgeLocation()">
            {{unlockFridgeText}}
          </button>
          <div *ngIf="fridgeResponse.length" class="fridge-text">{{fridgeResponse}}</div>
        </div>
        <!--        </div>-->
      </div>
      <div class="field" *ngIf="isTab">
        <div class="field__title">{{orderTabTitle}}</div>
        <ion-text class="field__description">Allow others to add to your tab by sharing this link with your table:
        </ion-text>
        <div class="field__description">
          <a class="field__description--link" href="{{tabLink}}">{{tabLink}}</a>
          <img class="field__share-tab-icon" [src]="'./assets/images/share_icon.svg'" [hidden]="isHideShareButton" alt="share icon" (click)="openShareOptions()"/>
        </div>

        <ion-button class="checkout-btns__btn" color="brand" expand="block" (click)="orderTabAgain()">Order again on your tab</ion-button>
        <ion-button fill="clear" class="checkout-btns__btn checkout-btns__cancel-btn" expand="block" (click)="closeTab()">Close your tab</ion-button>
      </div>
      <div class="divider"></div>
      <div class="field" *ngIf="sharedOrderService.sharedOrderId$">
        <div class="field__title">Successfully added items to shared order!</div>
      </div>
      <div class="field" *ngIf="orderCompletedStatus.length && !sharedOrderService.sharedOrderId$">
        <div class="field__title">Previous orders</div>
        <div class="field__content">
          <div class="order-tab__container">
            <app-order-completed-widget *ngFor="let orderStatus of orderCompletedStatus" [orderStatus]="orderStatus">
            </app-order-completed-widget>
          </div>
        </div>
      </div>
      <ng-container *ngIf="pastOrdersStatus && pastOrdersStatus.length > 0">
        <div class="divider"></div>
        <div class="field">
          <div class="field__title">Past customer orders</div>
          <div class="field__content">
            <div class="order-tab__container">
              <app-order-status *ngFor="let orderStatus of pastOrdersStatus" [estimatedTimeInMinutes]="getEstimatedTime(orderStatus)"
                                [orderStatus]="orderStatus" [customer]="customer" [hideETA]="true" [isGroup]="isGroup"
                                [currencySign]="restaurantStore.restaurantCountryInfo.currencySign"></app-order-status>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="spinner-wrapper" *ngIf="isLoading">
    <app-spinner></app-spinner>
  </div>
</ion-content>
